<template>
  <a-layout-footer class="footer">
    <a-row>
      <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <h3 class="title">NgadoMoe</h3>
        <p>Giving is about sincerity, not about price</p>
      </a-col>
      <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"></a-col>
      <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <h3 class="title">Social Media</h3>
        <a-flex horizontal gap="16">
          <a-typography-link
            href="https://www.instagram.com/ngadomoe.co/"
            rel="noopener"
            target="_blank"
          >
            <InstagramFilled class="icon" />
          </a-typography-link>
          <!-- <a-typography-link
            href="https://www.instagram.com/ngadomoe.co/"
            rel="noopener"
            target="_blank"
          >
            <Facebook class="icon" />
          </a-typography-link> -->
        </a-flex>
      </a-col>
    </a-row>
  </a-layout-footer>
</template>

<script src="./index.js"></script>
<style src="./style.less" lang="less" scoped></style>
